import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Category, CategoryNaturalKey } from '../../../documents/models/category';
import { reportTypeColumn, regionColumn, postedColumn, titleColumn, letterNumberColumn, zcProjectNumberColumn } from '../../../documents/documents-columns/documents-columns';
import {
    blindingRoleColumn, countryColumn, emailColumn,
    protocolNameColumn, sponsorNameColumn, studyRoleColumn,
    subcategoryTitleColumn, userNameColumn, subjectNumberAndInitialsColumn,
    timeBetweenReadAndPosted, accessionNumberColumns, getActivityReportsVersionColumn,
    readDateTimeColumn, visitColumn, visitCollectionDateColumn, eQueryIdColumn, createDateColumn, responseDateColumn, issueTypesColumn, statusColumn, responseAgeColumn, getCompositeSiteColumn
} from '../../../shared/activity-report/activity-reports-columns';
import { AdminLabManualActivityReport } from '../report-types/admin-lab-manual-activity-report';

@Injectable()
export class AdminActivityReportsDocumentsColumns {
    private columnsDictionary: { [key in CategoryNaturalKey]?: ColDef[] };

    constructor() {
        this.fillDataDictionary();
    }

    public getColumnDefinitions(category: Observable<Category>): Observable<ColDef[]> {
        return category.pipe(map(c => {
            const columns = this.columnsDictionary[c.categoryId] || [];
            return columns;
        }));
    }

    private fillDataDictionary() {
        const siteCommunicationsColumns = [
            titleColumn,
            letterNumberColumn,

            postedColumn,
            readDateTimeColumn,

            countryColumn,
            sponsorNameColumn,
            protocolNameColumn,
            zcProjectNumberColumn,
            getCompositeSiteColumn(),

            userNameColumn,
            emailColumn,
            studyRoleColumn,
            blindingRoleColumn,
        ];

        const siteActionsColumns = [
            titleColumn,
            subjectNumberAndInitialsColumn,
            visitColumn,
            visitCollectionDateColumn,
            accessionNumberColumns,
            
            postedColumn,
            readDateTimeColumn,
            
            countryColumn,
            sponsorNameColumn,
            protocolNameColumn,
            zcProjectNumberColumn,
            getCompositeSiteColumn(),

            userNameColumn,
            emailColumn,
            studyRoleColumn,
            blindingRoleColumn,
        ];

        const resultAlertsColumns = [
            subjectNumberAndInitialsColumn,
            visitColumn,
            visitCollectionDateColumn,
            accessionNumberColumns,

            postedColumn,
            readDateTimeColumn,

            countryColumn,
            sponsorNameColumn,
            protocolNameColumn,
            zcProjectNumberColumn,
            getCompositeSiteColumn(),

            userNameColumn,
            emailColumn,
            studyRoleColumn,
            blindingRoleColumn,
        ];

        const labManualsColumns = [
            subcategoryTitleColumn,
            getActivityReportsVersionColumn<AdminLabManualActivityReport>(),

            postedColumn,
            readDateTimeColumn,

            regionColumn,
            sponsorNameColumn,
            protocolNameColumn,
            zcProjectNumberColumn,
            getCompositeSiteColumn(),

            userNameColumn,
            emailColumn,
            studyRoleColumn,
            blindingRoleColumn,
        ];

        const trainingMaterialsColumns = [
            subcategoryTitleColumn,
            titleColumn,
            
            postedColumn,
            readDateTimeColumn,
            
            countryColumn,
            sponsorNameColumn,
            protocolNameColumn,
            getCompositeSiteColumn(),
            
            userNameColumn,
            emailColumn,
            studyRoleColumn,
            blindingRoleColumn,
        ];

        const labReportsColumns = [
            reportTypeColumn,
            subjectNumberAndInitialsColumn,
            visitColumn,
            visitCollectionDateColumn,
            accessionNumberColumns,
            
            postedColumn,
            readDateTimeColumn,
            
            countryColumn,
            sponsorNameColumn,
            protocolNameColumn,
            zcProjectNumberColumn,
            getCompositeSiteColumn(),

            userNameColumn,
            emailColumn,
            studyRoleColumn,
            blindingRoleColumn,
        ];

        const eQueryColumns = [
            sponsorNameColumn,
            protocolNameColumn,
            zcProjectNumberColumn,
            getCompositeSiteColumn(),
            countryColumn,
            visitColumn,
            visitCollectionDateColumn,
            accessionNumberColumns,
            subjectNumberAndInitialsColumn,
            eQueryIdColumn,
            createDateColumn,
            responseDateColumn,
            issueTypesColumn,
            statusColumn,
            responseAgeColumn,
            userNameColumn,
            emailColumn,
            studyRoleColumn,
        ];

        this.columnsDictionary = {
            'site-communications': siteCommunicationsColumns,
            'result-alerts': resultAlertsColumns,
            'site-actions': siteActionsColumns,
            'lab-manuals': labManualsColumns,
            'training-materials': trainingMaterialsColumns,
            'lab-reports': labReportsColumns,
            'equery': eQueryColumns
        };
    }
}
